export class ComboData {
    constructor(name?, value?){
      this.name = name;
      this.value = value;
    }
    name: string;
    value?: string;
}